export default "__VITE_ASSET__FIn8pg6o__"